import {
    getAxios,
} from './axios'

import {addAuthTokenData} from './member';

export function getMemberVirtualGifts(params = {}) {
    let axios = getAxios();

    return axios.request({
        url: '/member/virtual_gifts/',
        method: 'get',
        params: {...addAuthTokenData(params)}
    });
}


// WEBPACK FOOTER //
// ./src/backend-helpers/memberVirtualGifts.js